<mc-file-watcher (changed)="update($event)" [autostart]="true"></mc-file-watcher>

<mc-gate-readings-list [gateReadings]="gateReadings"></mc-gate-readings-list>
